import React from "react";

interface IErrorMessageProps {
  message: string;
  show: boolean;
}

export class ErrorMessage extends React.Component<IErrorMessageProps> {
  render() {
    const errorStyle = {
      color: "#9f3a38",
      marginTop: "0px",
    };
    return (
      <>
        {this.props.show ? (
          <label style={errorStyle}>{this.props.message}</label>
        ) : null}
      </>
    );
  }
}

export default ErrorMessage;
